import { ProposalCommandType } from 'graphql/generated'
import {
  getCommandDescription,
  IProposalCommandInputProps
} from './ProposalCommand.types'
import { useEffect } from 'react'

function ChangeRequireVoteSignatureCommand({
  onChange,
  onValidityChange,
  collective
}: IProposalCommandInputProps) {
  useEffect(() => {
    onChange({
      type: ProposalCommandType.CHANGE_REQUIRE_VOTE_SIGNATURE,
      requireVotingSignature: !collective.parameters.requireVotingSignature
    })
    // eslint-disable-next-line
  }, [collective.parameters.requireVotingSignature])

  const isValid = true
  useEffect(() => {
    onValidityChange(isValid)
    // eslint-disable-next-line
  }, [isValid])

  return (
    <div className="flex flex-col w-full">
      <div className="flex pt-4 justify-center items-center">
        <p className="text-gray-700 font-light text-sm">
          {getCommandDescription(
            ProposalCommandType.CHANGE_REQUIRE_VOTE_SIGNATURE,
            collective
          )}
        </p>
      </div>
    </div>
  )
}

export default ChangeRequireVoteSignatureCommand
